import { render, staticRenderFns } from "./generalActionDialog.vue?vue&type=template&id=2bcadd6d&"
import script from "./generalActionDialog.vue?vue&type=script&lang=js&"
export * from "./generalActionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports